<template>
	<div class="text-right pb10 toolbar" >
    <el-button
      v-for="(item,index) in config"
      type="primary" @click="item.bindClick" :key="index" v-if="item.setPower()">{{item.label()}}
    </el-button>
  </div>
</template>
<script>
  export default {
    props: {
      config: {
        type: Array,
        default: null
      }
    },
  }
</script>